import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * lot DJ2 — aperçu d'une cloche sorti de la barre du haut.
 * ⛔ La barre est `sticky z-40` : elle crée un contexte d'empilement, donc un aperçu rendu DANS la
 * barre reste plafonné à 40 et passe SOUS les en-têtes de pages en `z-50`. L'aperçu est donc rendu
 * dans `document.body`, en `position: fixed`, `z-index` 60, calé sous le bouton (bords droits
 * alignés). Position recalculée au redimensionnement, fermeture au défilement de la page et au
 * clic extérieur.
 */
export const ApercuFlottant = ({ ancreRef, onFermer, largeur = 384, children, ...reste }) => {
  const conteneur = useRef(null);
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    const calculer = () => {
      const rect = ancreRef.current?.getBoundingClientRect();
      if (!rect) return;
      setPosition({ top: Math.round(rect.bottom + 8),
        right: Math.max(8, Math.round(window.innerWidth - rect.right)) });
    };
    calculer();
    window.addEventListener('resize', calculer);
    return () => window.removeEventListener('resize', calculer);
  }, [ancreRef]);

  useEffect(() => {
    const dehors = (evenement) => {
      if (conteneur.current?.contains(evenement.target)
          || ancreRef.current?.contains(evenement.target)) return;
      onFermer();
    };
    const defilement = (evenement) => {
      if (conteneur.current?.contains(evenement.target)) return; // liste interne
      onFermer();
    };
    document.addEventListener('mousedown', dehors);
    window.addEventListener('scroll', defilement, true);
    return () => {
      document.removeEventListener('mousedown', dehors);
      window.removeEventListener('scroll', defilement, true);
    };
  }, [ancreRef, onFermer]);

  if (!position) return null;

  return createPortal(
    <div
      ref={conteneur}
      style={{ position: 'fixed', top: position.top, right: position.right, zIndex: 60,
        width: largeur, maxWidth: 'calc(100vw - 16px)' }}
      {...reste}
    >
      {children}
    </div>,
    document.body,
  );
};

export default ApercuFlottant;
